import type React from 'react';

export interface IContent {
  storageKey: string;
  image?: string;
  title: string;
  description: React.ReactNode;
  beta_module?: string;
}

export const contents: IContent[] = [];
